import { matchPath } from 'react-router-dom';

export interface FederatedPageModuleLike {
  componentPosition?: string;
  componentPage?: string;
  public?: boolean;
}

const ensureLeadingSlash = (componentPage: string): string =>
  (componentPage.startsWith('/') ? componentPage : `/${componentPage}`);

export const pathnameMatchesFederatedPagePattern = (
  componentPage: string,
  pathname: string,
): boolean => {
  const pattern = ensureLeadingSlash(componentPage);
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;

  return matchPath({ path: pattern, end: true }, path) != null;
};

/** True se algum módulo de página federada marcado como `public` casa com o pathname (inclui `:param`). */
export const isPathPublicFederatedPage = (
  modules: FederatedPageModuleLike[],
  pathname: string,
): boolean =>
  modules.some(
    (m) =>
      m.componentPosition === 'page' &&
      Boolean(m.public) &&
      typeof m.componentPage === 'string' &&
      pathnameMatchesFederatedPagePattern(m.componentPage, pathname),
  );
